<div class="aca-admin aca-task">
  <!-- breadcrumb -->
  <nav class="aca-task__crumbs" aria-label="breadcrumb">
    <a routerLink="/" class="aca-task__crumbhome" [attr.aria-label]="'DMS.NAV.HOME' | translate"><mat-icon>home</mat-icon></a>
    <mat-icon class="aca-task__crumbsep">chevron_right</mat-icon>
    <a routerLink="/my-work" class="aca-task__crumblink">{{ 'DMS.MYWORK.TITLE' | translate }}</a>
    <mat-icon class="aca-task__crumbsep">chevron_right</mat-icon>
    <span class="aca-task__crumbhere">{{ 'DMS.TASK.CRUMB' | translate }}</span>
  </nav>

  <aca-page-header icon="assignment" [title]="'DMS.TASK.CRUMB' | translate" [subtitle]="task()?.name || ''" />

  <mat-progress-bar mode="indeterminate" *ngIf="loading() || working()" />

  <aca-page-state
    *ngIf="!loading() && !task()"
    state="error"
    icon="error_outline"
    [title]="'DMS.TASK.NOT_FOUND' | translate"
    [message]="'DMS.TASK.NOT_FOUND_HINT' | translate"
  />

  <div class="aca-task__body" *ngIf="task() as t">
    <!-- left: document viewer -->
    <section class="aca-task__viewer">
      <adf-alfresco-viewer
        *ngIf="t.docId; else noDoc"
        [nodeId]="t.docId"
        [overlayMode]="false"
        [showToolbar]="true"
        [allowGoBack]="false"
        [allowFullScreen]="true"
        [allowLeftSidebar]="true"
        [showLeftSidebar]="false"
      />
      <ng-template #noDoc>
        <div class="aca-task__nodoc">
          <mat-icon>description</mat-icon>
          <p>{{ 'DMS.TASK.NO_DOC' | translate }}</p>
        </div>
      </ng-template>
    </section>

    <!-- right: the cards -->
    <aside class="aca-task__side">
      <!-- document info -->
      <section class="aca-task__card" *ngIf="t.docId">
        <header class="aca-task__cardhead">
          <h3 class="aca-task__cardtitle"><mat-icon>description</mat-icon>{{ 'DMS.TASK.DOC_INFO' | translate }}</h3>
          <button type="button" class="aca-task__outline aca-task__outline--sm" (click)="openDoc()">
            <mat-icon>open_in_new</mat-icon>{{ 'DMS.MYWORK.OPEN_DOC' | translate }}
          </button>
        </header>
        <div class="aca-task__docrow">
          <span class="aca-task__file" [ngClass]="fileClass(t.docName)"
            ><mat-icon>{{ fileIcon(t.docName) }}</mat-icon></span
          >
          <div class="aca-task__docmeta">
            <span class="aca-task__docline">
              <strong>{{ t.docName }}</strong>
              <span class="aca-task__doctype" *ngIf="docType()">{{ docType() | translate }}</span>
            </span>
            <p class="aca-task__docdesc" *ngIf="docDesc()">{{ docDesc() }}</p>
          </div>
        </div>
        <div class="aca-task__facts" *ngIf="docFacts().length">
          <div class="aca-task__fact" *ngFor="let f of docFacts()">
            <span class="aca-task__factlabel">{{ f.label | translate }}</span>
            <strong class="aca-task__factval">{{ f.date ? (f.value | acaDate: 'd MMM y') : f.key ? (f.value | translate) : f.value }}</strong>
          </div>
        </div>
      </section>

      <!-- task info -->
      <section class="aca-task__card">
        <header class="aca-task__cardhead">
          <h3 class="aca-task__cardtitle">
            <mat-icon>assignment</mat-icon>{{ 'DMS.TASK.INFO' | translate }}
            <span class="aca-work__chip" [ngClass]="'aca-work__chip--' + tasksKind(t)">{{ kindLabel(t) | translate }}</span>
          </h3>
          <span class="aca-task__duebadge" *ngIf="dueBadge() as b" [class.aca-task__duebadge--late]="b.late">
            <mat-icon>{{ b.late ? 'error_outline' : 'schedule' }}</mat-icon>
            <span>
              {{ b.key | translate: b.params }}
              <small>{{ badgeDate() | acaDate: 'd MMM y' }}</small>
            </span>
          </span>
        </header>
        <div class="aca-task__docrow">
          <span class="aca-task__file aca-task__file--task"><mat-icon>description</mat-icon></span>
          <div class="aca-task__docmeta">
            <strong>{{ t.name }}</strong>
            <p class="aca-task__docdesc" *ngIf="t.description">{{ t.description }}</p>
          </div>
        </div>
        <div class="aca-task__facts">
          <div class="aca-task__fact">
            <span class="aca-task__factlabel">{{ 'DMS.TASK.F_KIND' | translate }}</span>
            <strong class="aca-task__factval">{{ kindLabel(t) | translate }}</strong>
          </div>
          <div class="aca-task__fact">
            <span class="aca-task__factlabel">{{ 'DMS.TASK.ASSIGNEE' | translate }}</span>
            <strong class="aca-task__factval">{{ t.assignee || candidates() || ('DMS.TASK.UNASSIGNED' | translate) }}</strong>
          </div>
          <div class="aca-task__fact">
            <span class="aca-task__factlabel">{{ 'DMS.TASK.ASSIGNED_AT' | translate }}</span>
            <strong class="aca-task__factval">{{ (t.startedAt | acaDate: 'd MMM y HH:mm') || '—' }}</strong>
          </div>
          <div class="aca-task__fact">
            <span class="aca-task__factlabel">{{ 'DMS.TASK.PRIORITY' | translate }}</span>
            <strong
              class="aca-task__factval aca-task__factval--flag"
              [ngClass]="'aca-task__prio--' + (t.priority === 1 ? 'high' : t.priority === 3 ? 'low' : 'med')"
            >
              <mat-icon>flag</mat-icon>{{ priorityLabel(t.priority) | translate }}
            </strong>
          </div>
          <div class="aca-task__fact">
            <span class="aca-task__factlabel">{{ 'DMS.TASK.F_TASK_ID' | translate }}</span>
            <strong class="aca-task__factval aca-task__mono">WF-{{ t.processId }}</strong>
          </div>
        </div>
      </section>

      <!-- approval stepper -->
      <section class="aca-task__card" *ngIf="steps().length">
        <h3 class="aca-task__cardtitle"><mat-icon>account_tree</mat-icon>{{ 'DMS.TASK.STEPS' | translate }}</h3>
        <ol class="aca-task__stepper">
          <li *ngFor="let s of steps(); let i = index" class="aca-task__step" [ngClass]="'aca-task__step--' + s.state">
            <span class="aca-task__stepdot">
              <mat-icon *ngIf="s.state === 'done'">check</mat-icon>
              <b *ngIf="s.state !== 'done'">{{ i + 1 }}</b>
            </span>
            <span class="aca-task__stepname">{{ s.name | translate }}</span>
            <span class="aca-task__stepwho">{{ s.who || '—' }}</span>
            <span class="aca-task__stepat" *ngIf="s.state === 'active'">{{ 'DMS.MYWORK.STATE_RUNNING' | translate }}</span>
            <span class="aca-task__stepat" *ngIf="s.state !== 'active'">{{ (s.at | acaDate: 'd MMM y HH:mm') || '—' }}</span>
          </li>
        </ol>
      </section>

      <!-- what earlier reviewers decided, and why — the next one reads it before deciding -->
      <section class="aca-task__card" *ngIf="decisions().length">
        <h3 class="aca-task__cardtitle"><mat-icon>forum</mat-icon>{{ 'DMS.TASK.DECISIONS' | translate }}</h3>
        <ul class="aca-task__decisions">
          <li *ngFor="let d of decisions()" class="aca-task__decision" [ngClass]="'aca-task__decision--' + (d.outcome | lowercase)">
            <span class="aca-task__decisionhead">
              <strong>{{ d.name }}</strong>
              <span class="aca-task__decisionoutcome">{{ 'DMS.TASK.OUTCOME_' + (d.outcome | uppercase) | translate }}</span>
            </span>
            <span class="aca-task__decisionmeta">{{ d.by || '—' }} · {{ d.at | acaDate: 'd MMM y HH:mm' }}</span>
            <q class="aca-task__decisioncomment" *ngIf="d.comment">{{ d.comment }}</q>
          </li>
        </ul>
      </section>

      <!-- actions — driven by the task's state and definition kind -->
      <section class="aca-task__card" *ngIf="!isDone()">
        <h3 class="aca-task__cardtitle"><mat-icon>bolt</mat-icon>{{ 'DMS.TASK.ACTIONS' | translate }}</h3>

        <ng-container *ngIf="isClaimable()">
          <p class="aca-task__hint">{{ 'DMS.TASK.CLAIM_HINT' | translate }}</p>
          <button type="button" class="aca-task__primary" (click)="claim()" [disabled]="working()">
            <mat-icon>pan_tool</mat-icon>{{ 'DMS.MYWORK.CLAIM' | translate }}
          </button>
        </ng-container>

        <ng-container *ngIf="!isClaimable()">
          <label class="aca-task__comment">
            <span class="aca-task__commenthead">
              {{ 'DMS.TASK.COMMENT' | translate }}
              <small class="aca-task__counter">{{ comment.length }}/1,000</small>
            </span>
            <textarea rows="3" [maxLength]="commentMax" [(ngModel)]="comment" [placeholder]="'DMS.TASK.COMMENT_PH' | translate"></textarea>
          </label>

          <div class="aca-task__attach">
            <div class="aca-task__attachhead">
              <span
                >{{ 'DMS.TASK.ATTACH' | translate }} <small>{{ 'DMS.TASK.ATTACH_OPT' | translate }}</small></span
              >
              <button type="button" class="aca-task__outline aca-task__outline--sm" (click)="pickAttach()" [disabled]="attachBusy()">
                <mat-icon>attach_file</mat-icon>{{ 'DMS.TASK.ATTACH_BTN' | translate }}
              </button>
            </div>
            <ul class="aca-task__attlist" *ngIf="items().length">
              <li *ngFor="let d of items()">
                <mat-icon>description</mat-icon>
                <button type="button" class="aca-task__attlink" (click)="openItem(d)">{{ d.name }}</button>
              </li>
            </ul>
            <small class="aca-task__atthint">{{ 'DMS.TASK.ATTACH_HINT' | translate }}</small>
            <input #attachInput type="file" hidden accept=".pdf,image/*" (change)="onAttachFile($event)" />
          </div>

          <div class="aca-task__btns">
            <ng-container *ngIf="isReview()">
              <button type="button" class="aca-task__danger" (click)="act('Reject')" [disabled]="working()">
                <mat-icon>undo</mat-icon>{{ 'DMS.TASK.SEND_BACK' | translate }}
              </button>
              <button type="button" class="aca-task__outline" (click)="reassign()" [disabled]="working()">
                <mat-icon>swap_horiz</mat-icon>{{ 'DMS.TASK.REASSIGN' | translate }}
              </button>
              <button type="button" class="aca-task__ok" data-automation-id="dms-task-approve" (click)="act('Approve')" [disabled]="working()">
                <mat-icon>check</mat-icon>{{ 'DMS.TASK.APPROVE' | translate }}
              </button>
            </ng-container>
            <ng-container *ngIf="!isReview()">
              <button type="button" class="aca-task__outline" *ngIf="t.docId" (click)="updateDoc()">
                <mat-icon>upload_file</mat-icon>{{ 'DMS.TASK.UPDATE_DOC' | translate }}
              </button>
              <button type="button" class="aca-task__outline" (click)="reassign()" [disabled]="working()">
                <mat-icon>swap_horiz</mat-icon>{{ 'DMS.TASK.REASSIGN' | translate }}
              </button>
              <button type="button" class="aca-task__ok" (click)="act()" [disabled]="working()">
                <mat-icon>check</mat-icon>{{ 'DMS.TASK.COMPLETE' | translate }}
              </button>
            </ng-container>
          </div>
        </ng-container>
      </section>

      <section class="aca-task__card" *ngIf="isDone()">
        <p class="aca-task__done">
          <mat-icon>task_alt</mat-icon>{{ 'DMS.TASK.IS_DONE' | translate }}
          <a [routerLink]="['/workflows/instances', t.processId]">{{ 'DMS.TASK.TRACK' | translate }}</a>
        </p>
      </section>
    </aside>
  </div>
</div>
